import { useCallback } from 'react'
import {
  EVENT_TRACKING,
  trackStoreHoursEvent,
  useTrackStoreEventMetaData,
} from './utils/eventTracking'
import { useDomainGoToPath } from './utils/domain/routing'

export { SUPPORTED_RETAILER_SERVICE_TYPES } from './utils/useFormToApiDataMapping.hooks'
export { StoreHoursBulkStoreHoursDetails } from './components/store-list-grid/components/store-hours-detail/StoreHoursBulkStoreHoursDetails'
export { StoreHoursBulkHolidaysList } from './components/holidays/components/list/StoreHoursBulkHolidaysList'
export { useGoToEditStoreHours } from './utils/useGoToEditStoreHours.hooks'
export { useGoToUpdateHistory } from './utils/useGoToUpdateHistory.hooks'
export { useHasModifyHoursAccess } from './utils/useHasModifyHoursAccess.hooks'

export const useTrackSingleStoreEditClicked = () => {
  const metadata = useTrackStoreEventMetaData(EVENT_TRACKING.singleStoreEditClicked)

  return useCallback(() => {
    trackStoreHoursEvent(EVENT_TRACKING.singleStoreEditClicked, metadata)
  }, [metadata])
}

export const useGoToStoreHoursEditStoreHour = (warehouseLocationId: string) =>
  useDomainGoToPath('store-hours-bulk-edit', undefined, undefined, undefined, {
    storeIds: warehouseLocationId,
  })
